import { create } from 'zustand';

/** Lets a page (e.g. the study view) surface the current patient in the global
 *  top bar, which is rendered by AppLayout above all routes. */
interface Patient {
  patientName?: string;
  patientId?: string;
  patientSex?: string;
  patientAge?: string;
  patientBirthDate?: string;
  patientIdIssuer?: string;
  referringPhysician?: string;
  accession?: string;
  studyDateTime?: string;
}

interface HeaderState extends Patient {
  setPatient: (p: Patient) => void;
  clear: () => void;
}

const empty: Patient = {
  patientName: undefined,
  patientId: undefined,
  patientSex: undefined,
  patientAge: undefined,
  patientBirthDate: undefined,
  patientIdIssuer: undefined,
  referringPhysician: undefined,
  accession: undefined,
  studyDateTime: undefined,
};

export const useHeaderStore = create<HeaderState>((set) => ({
  setPatient: (p) => set({ ...empty, ...p }),
  clear: () => set(empty),
}));
